// eslint-disable-next-line @typescript-eslint/no-empty-function
export const noop = () => {};

export const identity = (x) => x;

export const empty = () => ({});
